import AuditHistoryComponent from '@components/ehss/history/AuditHistoryComponent';
import Table from '@components/TableComponent';
import { AuditPersonType } from '@interfaces/audit-person-type';
import { ComponentType } from '@interfaces/component-type';
import { IAudited } from '@interfaces/ehss/Audited';
import { IAuditor } from '@interfaces/ehss/Auditor';
import { IAudit as IProcess } from '@interfaces/ehss/IAudit';
import { IProcess } from '@interfaces/ehss/Process';
import Ticket from '@interfaces/ehss/ticket';
import { FrequencyType } from '@interfaces/global/config-ehss';
import Register from '@interfaces/register';
import AppContext from '@services/Context';
import AuditorService from '@services/ehss/Auditor';
import ProcessService from '@services/ehss/Process';
import ConfigService from '@services/global/Config';
import ProcessManagementService from '@services/ProcessManagement';
import TicketEvent from '@services/TicketEvent';
import TicketServiceEhss from '@services/TicketServiceEhss';
import { Routes } from '@src/helpers/_routes';
import NotificationComponent from '@src/helpers/_showNotifications';
import { StatusProcess } from '@src/helpers/Enums';
import { Theme } from '@src/styled-components';
import { Avatar, Button, Card, Col, Divider, List, Modal, Progress, Radio, Row, Tabs } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import I18n from '../i18n';
import styled from '../styled-components';
import HistoryComponentEhss from './HistoryComponentEhss';

interface IAuditPersonDetailsPropType {
  actionUnlinkTest?: string;
  auditor?: boolean;
  auditChanged: any;
  auditChangedName?: any;
  auditedsByAuditor?: number;
  auditedsMinByAuditor?: number;
  auditedsMaxByAuditor?: number;
  auditedsGoal?: any;
  auditGoals?: any
  auditPersonType: AuditPersonType;
  audits: number;
  auditsGoal?: number;
  fields: any;
  onChoosePersonClick?: any;
  onUnlink?: any;
  personData: IAudited | IAuditor;
  tableColumns: any[];
  tableData: any[];
  toggleUserFormModal?: any;
  unlinkModalTitle?: string;
  setAuditedMinByAuditor?: Function;
  setAuditedMaxByAuditor?: Function;
  curOffset?: string;
  calledFromAuditedsPage?: boolean;
};

interface IAuditPersonDetailsStateType {
  auditedsTableData: IAuditedTableData[];
  auditorsTableData: IAuditorTableData[];
  processesData: IProcess[];
  auditsIds: string[];
  currentProcess?: IProcess;
  currentAuditedByAuditor: any;
  currentAuditedMinByAuditor: any;
  currentAuditedMaxByAuditor: any;
  currentAuditGoals: any;
  currentAuditId: string;
  currentAuditName: string;
  historyData?: IHistoryData[];
  loadingAudits: boolean;
  loadingHistory: boolean;
  ticketGroupAmount?: number;
  ticketGroupOffset?: string;
  currentAuditedAmount: number;
  historyTableData: any;
  visibleModal: boolean;
  currentTicket: any;
  extraFields?: any;
  loadingTicket: boolean;
  curOffset?: string;
  loadingSeeMore: boolean;
  auditedExecutedCount: number;
  resultTable: any[];
  auditsPerMonth: any;
  curOffsetLink?: string;
  isAuditedOut: boolean;
  resultAuditedsWithGroup: any;
  loadingDetails: boolean;
};

interface IHistoryData {
  loading: boolean;
  auditId: string;
  data: any;
  offset?: string;
  count?: number;
}

interface IAuditedTableData {
  loading: boolean;
  auditId: string;
  data: any;
}
interface IAuditorTableData {
  loading: boolean;
  auditId: string;
  data: IAuditor;
}

interface TicketsExecutedByAudited {
  auditedId: string;
  tickets: number;
}


const tableColumnsAuditor = [
  {
    title: 'labels.audited',
    dataIndex: 'value.audited.name',
    key: 'value.audited.name',
  },
  {
    title: 'table.startAt',
    dataIndex: 'startAt',
    key: 'startAt',
  }, {
    title: 'table.finishtAt',
    dataIndex: 'modifiedAt',
    key: 'modifiedAt',
  },

  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    width: '30%',
  }];

const tableColumnsAudited = [
  {
    title: 'labels.auditor',
    dataIndex: 'value.auditor.name',
    key: 'value.audited.name',
  },
  {
    title: 'table.startAt',
    dataIndex: 'startAt',
    key: 'startAt',
  }, {
    title: 'table.finishtAt',
    dataIndex: 'modifiedAt',
    key: 'modifiedAt',
  },

  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    width: '30%',
  }];

const TabPane = Tabs.TabPane;

export default class AuditPersonDetails extends React.Component<IAuditPersonDetailsPropType, IAuditPersonDetailsStateType>{
  extraInfos?: any = [];
  private unit: any;

  private _ticketServiceGlobal: ProcessManagementService = new ProcessManagementService();
  private _ticketService: TicketServiceEhss = new TicketServiceEhss();
  private _auditorService: AuditorService = new AuditorService();
  private _processService: ProcessService = new ProcessService;
  private _configService: ConfigService = new ConfigService();
  private _ticketEvent: any = new TicketEvent();

  constructor(props: any) {
    super(props);

    this.state = {
      historyData: [],
      ticketGroupAmount: undefined,
      ticketGroupOffset: '',
      loadingHistory: false,

      loadingAudits: true,
      processesData: [],
      auditsIds: [],
      currentAuditId: '',
      currentAuditName: '',
      currentAuditGoals: 0,
      currentProcess: undefined,
      auditedsTableData: [],
      auditorsTableData: [],
      currentAuditedByAuditor: '',
      currentAuditedMinByAuditor: '',
      currentAuditedMaxByAuditor: '',
      currentAuditedAmount: 1,
      historyTableData: [],
      visibleModal: false,
      currentTicket: undefined,
      loadingTicket: false,
      loadingSeeMore: false,
      auditedExecutedCount: 0,
      resultTable: [],
      auditsPerMonth: 0,
      isAuditedOut: false,
      resultAuditedsWithGroup: [],
      loadingDetails: false
    }
    this.formatExtraInfos();
  }

  setUnit = (unit: any) => {
    this.unit = unit;
  }

  componentDidMount() {
    this.initialData()
  }

  initialData = async () => {
    const { personData } = this.props;

    if (this.props.auditPersonType === AuditPersonType.AUDITOR) {
      if (personData.auditor !== undefined) {
        if (personData.auditor.processes !== undefined) {
          this.setState({ auditsIds: personData.auditor.processes });
        }
      }
    }
    else {
      if (personData.audited !== undefined) {
        if (personData.audited.processes !== undefined) {
          this.setState({ auditsIds: personData.audited.processes });
        }
      }
    }
    await this.getConfig();
    await this.getAudits();
    await this.getMadeAuditsJSON().then(response => this.getAuditionsDone(response, this.state.currentProcess.auditedGoal.times));
    this.getHistoryData(true, true)
  }

  getMadeAuditsJSON = async () => {
    const { personData } = this.props
    const date = new Date(new Date().getFullYear(), 0, 1)
    const query = this.props.auditor ? {
      unit: localStorage.getItem('activeUnitId'),
      from: date.getTime(),
      status: StatusProcess.DONE,

      auditor: personData.id
    } : {
        unit: localStorage.getItem('activeUnitId'),
        from: date.getTime(),
        status: StatusProcess.DONE,
        auditedOut: null,
        auditorGuest: false,
        audited: personData.id
      }


    const result = await this._ticketEvent.getDashboardAuditorAudited(query, this.state.currentProcess.id)
    const filterWithoutAuditedOut = result.filter((e: any) => e.value.auditedOut === false || e.value.auditedOut === undefined)
    this.setState({
      resultTable: result,
      resultAuditedsWithGroup: filterWithoutAuditedOut
    })
    return filterWithoutAuditedOut
  }

  formatExtraInfos = async () => {
    const { personData } = this.props;
    const listData: any[] = [];

    listData.push({
      title: I18n.l("table.auditors.registration"),
      content: personData.username
    });

    if (personData.fields !== undefined) {

      personData.fields.map((item) => {
        const _title = this.getFieldLabelById(item.label);
        if (_title !== undefined) {
          listData.push({
            title: _title,
            content: item.value,
          });
        }
      });
    }

    this.extraInfos = listData;
  };

  //#region AUDITS 
  getAudits = async () => {
    this.setState({ loadingAudits: true });

    const ids = this.state.auditsIds;
    let nextAuditsData: IProcess[] = [];

    if (ids && ids.length > 0) {
      try {
        // const data = await this._auditService.listByIds(this.unit, ids); 
        const dataProcesses: any = await this._processService.getByIds(this.unit, ids);
        nextAuditsData = [...dataProcesses];
      } catch (e) {
        NotificationComponent.Notify('error', I18n.l("audits.error.auditGetError"), e);
      }
    }

    let sortedProcessesData = [...nextAuditsData];
    if (!!nextAuditsData && nextAuditsData.length > 0) {
      sortedProcessesData = this.sortAuditsByName(nextAuditsData);

    }


    let newCurrentAuditGoals;
    if (this.props.auditPersonType === AuditPersonType.AUDITOR) {
      newCurrentAuditGoals = (nextAuditsData[0] !== undefined ? (nextAuditsData[0].auditedGoal.times || "") : "");
    }

    let newCurrentProcess: IProcess;
    const actualProcess = await sortedProcessesData.find(e => e.id === nextAuditsData[0].id);
    if (actualProcess) {
      newCurrentProcess = actualProcess;
    }


    this.setState({
      currentAuditId: (nextAuditsData[0] !== undefined ? (nextAuditsData[0].id || "") : ""),
      currentAuditName: (nextAuditsData[0] !== undefined ? (nextAuditsData[0].name || "") : ""),
      currentAuditGoals: newCurrentAuditGoals,
      currentAuditedMinByAuditor: (nextAuditsData[0] !== undefined ? (nextAuditsData[0].minAuditedsByAuditor || "") : ""),
      currentAuditedMaxByAuditor: (nextAuditsData[0] !== undefined ? (nextAuditsData[0].maxAuditedsByAuditor || "") : ""),
      loadingAudits: false,
      processesData: sortedProcessesData,
      currentProcess: newCurrentProcess ? newCurrentProcess : undefined,
    });


    if (!!nextAuditsData && nextAuditsData.length > 0) {
      if (this.props.auditChanged) {
        this.props.auditChanged(this.state.currentAuditId);
      }

      if (this.props.auditChangedName) {
        this.props.auditChangedName(this.state.currentAuditName);
      }

      if (this.props.auditGoals) {
        this.props.auditGoals(this.state.currentAuditGoals);
      }

      if (this.props.setAuditedMinByAuditor) {
        this.props.setAuditedMinByAuditor(this.state.currentAuditedMinByAuditor);
      }
      if (this.props.setAuditedMaxByAuditor) {
        this.props.setAuditedMaxByAuditor(this.state.currentAuditedMaxByAuditor);
      }
      this.loadTabData(this.state.currentAuditId);
    }
  }

  sortAuditsByName(audits: IProcess[]) {
    const auditsAux = [...audits];
    auditsAux.sort((a, b) => {
      if (a.name.toUpperCase() > b.name.toUpperCase()) {
        return 1;
      }
      if (a.name.toUpperCase() < b.name.toUpperCase()) {
        return -1;
      }
      // a must be equal to b 
      return 0;
    });
    return auditsAux;
  }
  //#endregion 

  //#region AUDITEDS 
  getAuditeds = async (auditId: string) => {
    const { personData } = this.props;

    const audit = auditId;

    let res: IAudited[] = [];
    try {
      res = await this._auditorService.auditedListByAudit(personData.id, audit);
      this.setState({ currentAuditedAmount: res.length });
      this.addAuditedsDataToAudit(audit, res, false);
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
      await this.setAuditedsDataTableLoading(audit, false);
      this.setState({
        // savingAuditor: false, 
      });
    }
    return res;
  }
  addAuditedsDataToAudit = async (auditId: string, auditedsData: any, loading: boolean) => {
    const { auditedsTableData } = this.state;

    const currentTableDataIndex = this.getAuditedsTableDataIndexByAudit(auditId);

    const newAuditedTableData = [...auditedsTableData];

    if (currentTableDataIndex !== -1) {
      if (newAuditedTableData[currentTableDataIndex].auditId !== auditId) {
        newAuditedTableData[currentTableDataIndex].auditId = auditId;
      }
      newAuditedTableData[currentTableDataIndex].data = auditedsData;
      newAuditedTableData[currentTableDataIndex].loading = loading;
    }
    else {
      const newData: any[] = [];
      newData.push(auditedsData);
      newAuditedTableData.push({
        auditId,
        data: newData,
        loading
      });
    }

    this.setState({
      auditedsTableData: newAuditedTableData
    });
  }

  addAuditedDataToAudit = async (auditId: string, auditedData: any, loading: boolean) => {
    const { auditedsTableData } = this.state;

    const currentTableDataIndex = this.getAuditedsTableDataIndexByAudit(auditId);

    const newAuditedTableData = [...auditedsTableData];

    if (currentTableDataIndex !== -1) {
      if (newAuditedTableData[currentTableDataIndex].auditId !== auditId) {
        newAuditedTableData[currentTableDataIndex].auditId = auditId;
      }
      newAuditedTableData[currentTableDataIndex].data.push(auditedData);
      newAuditedTableData[currentTableDataIndex].loading = loading;
    }
    else {
      const newData: any[] = [];
      newData.push(auditedData);
      newAuditedTableData.push({
        auditId,
        data: newData,
        loading
      });
    }
    this.setState({
      auditedsTableData: newAuditedTableData
    });
  }

  private removeAuditedDataFromTable = async (auditId: string, auditedId: string) => {
    const tableDataIndex = this.getAuditedsTableDataIndexByAudit(auditId);

    const newAuditedsTableData = [...this.state.auditedsTableData];

    if (!!newAuditedsTableData) {
      if (newAuditedsTableData[tableDataIndex].data.length > 0) {
        const dataIndexToRemove = newAuditedsTableData[tableDataIndex].data.findIndex((item: any) => item.id === auditedId);
        newAuditedsTableData[tableDataIndex].data.splice(dataIndexToRemove, 1);
      }
    }
    this.setState({ auditedsTableData: newAuditedsTableData });

  }

  setAuditedsDataTableLoading = async (auditId: string, loading: boolean) => {
    const { auditedsTableData } = this.state;
    const index = auditedsTableData.findIndex((item: IAuditedTableData) => item.auditId === auditId);

    if (index !== -1) {
      const nextAuditedsTableData = [...auditedsTableData];
      nextAuditedsTableData[index].loading = loading;
      this.setState({ auditedsTableData: nextAuditedsTableData });
    }
  }

  getAuditedsTableDataIndexByAudit(auditId: string) {
    const { auditedsTableData } = this.state;
    if (!!auditedsTableData) {
      return auditedsTableData.findIndex((item) => item.auditId === auditId);
    }
    return -1;
  }

  getAuditedsTableDataByAudit(auditId: string) {
    const { auditedsTableData } = this.state;
    let tableData;
    if (!!auditedsTableData) {
      tableData = auditedsTableData.find((item) => item.auditId === auditId);
    }
    if (!!tableData) {
      return tableData;
    }
    return undefined;
  }

  loadTabData = async (auditId: string) => {

    if (this.props.auditPersonType === AuditPersonType.AUDITOR) {
      if (this.getAuditedsTableDataIndexByAudit(auditId) === -1) {
        const newTableData: IAuditedTableData = {
          auditId,
          data: undefined,
          loading: true,
        }
        this.addAuditedsDataToAudit(auditId, newTableData, true);
        this.getAuditeds(auditId);
        // this.getHistoryData(auditId, true, true); 
      }
      else {
        await this.setAuditedsDataTableLoading(auditId, false);
      }
    }
    else {
      if (this.getAuditorTableDataIndexByAudit(auditId) === -1) {

        const newTableData: IAuditedTableData = {
          auditId,
          data: undefined,
          loading: true,
        }
        this.addAuditorDataToAudit(auditId, newTableData, true);
        this.getAuditors(auditId);
        // this.getHistoryData(auditId, true, true); 
      }
      else {

        this.setAuditorDataTableLoading(auditId, false);
      }
    }

  }

  auditedAdded(audit: string, data: IAuditor | IAudited) {
    this.addAuditedDataToAudit(audit, data, false);
  }
  auditedRemoved(audit: string, auditedId: string) {
    this.removeAuditedDataFromTable(audit, auditedId);
  }

  formatAuditedsToTable(auditedsData?: any, processesExecuted?: TicketsExecutedByAudited[]) {
    const tableDataAux: IAudited[] = Array.apply(null, { length: auditedsData.data.length > this.state.currentAuditedMaxByAuditor ? auditedsData.data.length : this.state.currentAuditedMaxByAuditor });
    const nextTableData: any[] = [];

    let minimumAuditEmpty = this.state.currentAuditedMinByAuditor;

    if (auditedsData !== undefined) {
      if (auditedsData.data !== undefined) {
        if (auditedsData.data.length > 0) {
          auditedsData.data.forEach((audited: IAudited) => {
            let indexInsert = 0;
            for (let i = 0; i < tableDataAux.length; i++) {
              if (tableDataAux[i] === undefined) {
                indexInsert = i;
                break;
              }
            }
            tableDataAux[indexInsert] = audited;
            minimumAuditEmpty = minimumAuditEmpty - 1;
          });
        }
      }
    }

    tableDataAux.map((audited) => {
      if (audited === undefined) {
        nextTableData.push({
          name: <div>
            <span className={'emptyRowData'}>
              {I18n.l("table.emptyRowData")}
            </span>
          </div>,
          username: <a onClick={this.props.toggleUserFormModal}>
            <span>
              {I18n.l("common.choose")}
              &ensp;
              {I18n.l("labels.audited").toLowerCase()}
            </span>
            {minimumAuditEmpty > 0 && (
              minimumAuditEmpty = minimumAuditEmpty - 1,
              <span>
                <Avatar className="goepik-small-left-margin" style={{ backgroundColor: '#D93838' }} icon="exclamation" />
              </span>
            )}

          </a>,
          actionDisabled: true,
        })
      }
      else {
        let executed = 0;
        if (processesExecuted) {
          const v = processesExecuted.find(e => e.auditedId == audited.id);
          if (v)
            executed = v.tickets;
        }

        nextTableData.push(this.formatDataToTableSingle(audited, executed));
      }
    });


    return nextTableData;
  }
  //#endregion 

  //#region AUDITORS 

  getAuditors = async (auditId: string) => {
    const audit = auditId;

    const auditorId = this.getAuditorIdFromAuditGoal(auditId);

    if (auditorId === undefined) {
      this.addAuditorDataToAudit(audit, undefined, false);
      return;
    }

    let res: IAuditor | undefined = undefined;
    try {

      res = await this._auditorService.getById(auditorId);

      this.addAuditorDataToAudit(audit, res, false);
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error === "An error occurred" || "Ocorreu um erro" || "Ha ocurrido un error" ? I18n.l("form.filter.errors.auditorNonExistent") : error);
      //NotificationComponent.Notify('error', "deu erro", error); 
      this.setAuditorDataTableLoading(audit, false);
    }
    return res;

  }

  getAuditorIdFromAuditGoal(auditId: string) {
    const { personData } = this.props;
    if (!!personData) {
      if (personData.audited) {
        if (personData.audited.goals && personData.audited.goals.length > 0) {
          const goalData = personData.audited.goals.find((item: any) => item.process === auditId);
          if (!!goalData) {
            if (!!goalData.auditor && goalData.auditor !== "") {
              return goalData.auditor;
            }
          }
        }
      }
    }

    return undefined;
  }

  addAuditorDataToAudit = async (auditId: string, auditorData: any, loading: boolean) => {
    const { auditorsTableData } = this.state;
    const currentTableDataIndex = this.getAuditorTableDataIndexByAudit(auditId);
    let newAuditorTableData = [...auditorsTableData];

    if (currentTableDataIndex !== -1) {
      if (newAuditorTableData[currentTableDataIndex].auditId !== auditId) {
        newAuditorTableData[currentTableDataIndex].auditId = auditId;
      }
      newAuditorTableData[currentTableDataIndex].data = auditorData;
      newAuditorTableData[currentTableDataIndex].loading = loading;
    }
    else {
      newAuditorTableData.push({
        auditId: auditId,
        data: auditorData,
        loading: loading
      });
    }

    this.setState({
      auditorsTableData: newAuditorTableData
    });
  }

  setAuditorDataTableLoading = async (auditId: string, loading: boolean) => {
    const { auditorsTableData } = this.state;
    const index = auditorsTableData.findIndex((item: IAuditorTableData) => item.auditId === auditId);

    if (index !== -1) {
      const nextAuditorsTableData = [...auditorsTableData];
      nextAuditorsTableData[index].loading = loading;
      this.setState({ auditedsTableData: nextAuditorsTableData });
    }
  }

  getAuditorsTableDataByAudit(auditId: string) {
    const { auditorsTableData } = this.state;
    let tableData;
    if (!!auditorsTableData) {
      tableData = auditorsTableData.find((item) => item.auditId === auditId);
    }
    if (!!tableData) {
      return tableData;
    }
    return undefined;
  }
  formatAuditorsToTable(auditorData: any) {
    let nextTableData: any[] = [];

    if (auditorData !== undefined) {
      if (auditorData.data !== undefined) {
        nextTableData.push(this.formatDataToTableSingle(auditorData.data));
      }
    }

    return nextTableData;
  }
  getAuditorTableDataIndexByAudit(auditId: string) {
    const { auditorsTableData } = this.state;
    if (!!auditorsTableData)
      return auditorsTableData.findIndex((item) => item.auditId === auditId);
    return -1;
  }

  //#endregion 
  formatDataToTableSingle = (item: IAudited, processesExecuted?: number) => {
    let nextData: any;
    let sumMonth: any[] = []
    let executedVal = 0

    for (let audited of this.state.resultTable) {
      if (audited.value.audited.id === item.id) {
        const value = sumMonth[`${audited.month}`] || 0;
        sumMonth[`${audited.month}`] = value + audited.count;
      }
    }

    if (!this.props.auditor) {
      if (this.props.auditPersonType === AuditPersonType.AUDITOR) {
        let auditsInfo =
          <div>
            {executedVal}
            &ensp;
            {I18n.l('common.of')}
            &ensp;
            {this.props.auditedsGoal}
          </div>

        let linkAuditedDetails = <Link to={`${Routes.auditeds}/${item.id}`}>{item.name}</Link>;
        nextData = {
          id: item.id,
          name: linkAuditedDetails,
          username: item.username,
          audits: auditsInfo,
        };
      }
      else {
        let linkAuditorDetails = <Link to={`${Routes.auditors}/${item.id}`}>{item.name}</Link>;
        nextData = {
          id: item.id,
          name: linkAuditorDetails,
          username: item.username,
        };
      }
    }
    else {
      let auditsInfo =
        <div>
          {executedVal}
          &ensp;
          {I18n.l('common.of')}
          &ensp;
          {this.props.auditedsGoal}
        </div>

      let linkAuditedDetails = <Link to={`${Routes.auditeds}/${item.id}`}>{item.name}</Link>;
      nextData = {
        id: item.id,
        name: linkAuditedDetails,
        username: item.username,
        audits: auditsInfo,
      };
    }

    return nextData;
  }

  getFieldLabelById = (guid: string): string | undefined => {
    if (this.props.fields !== undefined && this.props.fields.userFields !== undefined) {
      const fieldObject = this.props.fields.userFields.find((item: any) => item.id === guid)
      return fieldObject !== undefined ? fieldObject.name : undefined;
    }
    return undefined;
  }

  getHistoryData = async (reset: boolean, showLoading: boolean) => {
    let personId = this.props.personData.id;
    let response: any;

    if (!personId) {
      return;
    }
    this.setState({
      loadingHistory: showLoading,
    });

    try {
      if (this.props.auditPersonType === AuditPersonType.AUDITOR) {
        response = await this._ticketService.pagingTicket(this.state.currentAuditId, {
          unit: this.unit,
          limit: 10,
          auditorId: personId,
          offset: this.state.curOffset,
        });

      }

      else {
        response = await this._ticketService.pagingTicket(this.state.currentAuditId, {
          unit: this.unit,
          limit: 10,
          auditedId: personId,
        });
      }

      let newTicketData: Ticket[] = [];

      if (!reset) {
        newTicketData = this.state.historyTableData || [];
      }
      newTicketData = newTicketData.concat(response.items);
      this.setState({
        historyTableData: newTicketData,
        loadingHistory: false,
        loadingSeeMore: false,
        curOffset: response.offset,
      })



    } catch (error) {
      this.setAuditHistoryLoading('', false);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchHistory"), error);
      this.setState({
        loadingHistory: false,
      });
    }

  }

  async loadMoreHistory() {
    this.setState({ loadingSeeMore: true });
    await this.getHistoryData(false, true);
  }



  addHistoryDataToAudit = async (auditId: string, data: any, loading: boolean, offset?: string, count?: number) => {
    const { historyData } = this.state;
    const historyIndex = this.getHistoryIndexByAudit(auditId);
    let newHistoryData = [...historyData];

    let historyDataItems = [];

    if (data && data.length > 0) {
      historyDataItems = [...data];
    }

    if (historyDataItems) {
      if (historyDataItems && historyDataItems.length > 0) {
        historyDataItems.forEach((ticket: Ticket) => {
          if (ticket) {
            if (ticket.registers && ticket.registers.length > 0) {
              ticket.registers.forEach((register: Register<any>) => {
                if (register.value.sections && register.value.sections.length > 0) {
                  let comps = this.getTicketComponents(register.value.sections[0].id, register);
                  register.value.components = comps;
                }
              })
            }
          }
        })
      }
    }

    if (historyIndex !== -1) {
      if (newHistoryData[historyIndex].auditId !== auditId) {
        newHistoryData[historyIndex].auditId = auditId;
      }
      newHistoryData[historyIndex].data = historyDataItems;
      newHistoryData[historyIndex].loading = loading;
      newHistoryData[historyIndex].offset = offset;
      newHistoryData[historyIndex].count = count;
    }
    else {
      newHistoryData.push({
        auditId: auditId,
        data: historyDataItems,
        loading: loading,
        offset: offset,
        count: count,
      });
    }

    this.setState({
      historyData: newHistoryData
    });
  }

  getTicketComponents(sectionId: string, register: Register<any>): any[] {
    const section = register.value.sections.find((item: any) => item.id === sectionId);

    let components: any[] = [];

    if (section) {
      section.components.forEach((comp: any) => {
        components.push(comp);

        switch (comp.type) {
          case ComponentType.GOTO:
            if (comp.nexts) {
              comp.nexts.forEach((next: any) => {
                const gotoComponents = this.getTicketComponents(next, register);
                components = components.concat(gotoComponents);
              });
            }
            break;
        }
      });

      if (section.next) {
        const newComponents = this.getTicketComponents(section.next, register);
        components = components.concat(newComponents);
      }
    }

    return components;
  }

  setAuditHistoryLoading = async (auditId: string, loading: boolean) => {
    const { historyData } = this.state;

    if (historyData) {
      const index = historyData.findIndex((item: IHistoryData) => item.auditId === auditId);

      if (index !== -1) {
        const newHistoryData = [...historyData];
        newHistoryData[index].loading = loading;
        this.setState({ historyData: newHistoryData });
      }
    }
  }

  getHistoryIndexByAudit(auditId: string) {
    const { historyData } = this.state;
    if (!!historyData)
      return historyData.findIndex((item) => item.auditId === auditId);
    return -1;
  }
  getHistoryDataByAudit(auditId: string) {
    const { historyData } = this.state;
    let newHistoryData;
    if (historyData) {
      newHistoryData = historyData.find((item) => item.auditId === auditId);
    }
    if (newHistoryData) {
      return newHistoryData;
    }
    return undefined;
  }

  getAuditExecutedAmountByAudit(dataItem: IAudited | IAuditor, auditId: string) {

    if (this.props.auditPersonType === AuditPersonType.AUDITOR) {
      if (dataItem !== undefined) {
        if (dataItem.audited && dataItem.audited.goals !== undefined && dataItem.audited.goals.length > 0) {
          const goal = dataItem.audited.goals.find((item: any) => item.process === auditId);
          if (!!goal) {
            if (!!goal.auditExecuted) {
              return goal.auditExecuted;
            }
          }
          return 0;
        }
      }
    }
    else {
      if (dataItem !== undefined !== undefined) {
        if (dataItem.auditor && dataItem.auditor.goals !== undefined && dataItem.auditor.goals.length > 0) {
          const goal = dataItem.auditor.goals.find((item: any) => item.process === auditId);
          if (!!goal) {
            if (!!goal.auditExecuted) {
              return goal.auditExecuted;
            }
          }
          return 0;
        }
      }
    }
    return 0;
  }

  getAuditGoalAmountById(auditId?: string, auditedsAmount?: number): number {
    const { processesData, currentAuditedMinByAuditor } = this.state;

    const process = processesData.find((item: IProcess) => item.id === auditId);

    let goalTimes = 1;
    let totalGoal = 1;
    let frequency = 1;

    if (!!process) {
      if (!!process.auditedGoal && process.auditedGoal.times) {
        goalTimes = process.auditedGoal.times;
        if (process.auditedGoal.type === FrequencyType.MONTHS) {
          frequency = 12;
        }
      }
    }

    let auditorCount = currentAuditedMinByAuditor || 1;
    if (auditedsAmount != undefined) {
      if (auditedsAmount > auditorCount) {
        auditorCount = auditedsAmount;
      }
    }

    totalGoal = goalTimes * auditorCount;
    totalGoal = totalGoal * frequency;

    return totalGoal;
  }

  toggleVisualize = async (currentTicket: any) => {

    this.setState({
      visibleModal: !this.state.visibleModal,
      loadingTicket: true
    })
    const ticket = await this._ticketServiceGlobal.getGLOBAL(currentTicket.ticketId, true)
    this.setState({
      currentTicket: ticket,
      loadingTicket: false
    })
  }

  getConfig = async () => {
    try {
      const data: any = await this._configService.getGLOBAL();
      this.setState({
        extraFields: data.userFields,
      });
    } catch (error) {
      console.warn(error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.update"), error);
    }
  };

  renderHistoryTabData() {
    const historyTabData = (this.state.historyData ? this.getHistoryDataByAudit(this.state.currentAuditId) : undefined);

    let historyData = undefined;
    if (historyTabData) {
      if (historyTabData.data) {
        historyData = historyTabData.data;
      }
    }
    return (
      <Col xs={24} sm={24} md={24} >
        <AuditHistoryComponent
          data={historyData}
          loadingData={(historyTabData) ? historyTabData.loading : true}
          reloadTicketGroupsClick={() => this.reloadHistoryData()}
          auditPersonType={this.props.auditPersonType}
          showSeeMoreBtn={historyTabData ? (historyTabData.offset ? true : false) : false}
          onLoadMoreTickets={() => this.loadMoreHistory()}
        />
      </Col>
    )
  }

  renderAuditedsDataTable(data: any, processesExecuted: TicketsExecutedByAudited[]) {
    let tableData = this.formatAuditedsToTable(data, processesExecuted);
    if (!!data) {
      if (data.loading === true) {
        return (
          <Row>
            {I18n.l("common.loadingData")}
          </Row>
        )
      }
      return (
        <React.Fragment>
          <Row>
            <Avatar style={{ backgroundColor: '#D93838' }} icon="exclamation" />
            <span className="goepik-medium-left-margin title2">{I18n.l('table.auditors.requiredPositions')}</span>
          </Row>
          <Row style={{ paddingBottom: '2rem' }} className="goepik-component-padding">
            <Table
              className="AuditPersonDetails"
              columns={this.props.tableColumns}
              data={tableData}
              onUnlink={this.props.onUnlink}
              actionDeleteText={this.props.actionUnlinkTest}
              noPagination={true}
              showConfirmationModal={false}
              customModalTitle={this.props.unlinkModalTitle}
            />
          </Row>
        </React.Fragment>
      )
    }
    return (
      <div><p className="goepik-text-lightGray-bold">{I18n.l('common.noResult')}</p></div >
    )
  }


  renderAuditorsDataTable() {
    const data = (this.state.auditorsTableData ? this.getAuditorsTableDataByAudit(this.state.currentAuditId) : undefined);
    const tableData = this.formatAuditorsToTable(data);
    if (!!data) {

      if (!!tableData && tableData.length > 0) {
        return (
          <React.Fragment>
            <Row>
              <Table
                columns={this.props.tableColumns}
                data={tableData}
                onUnlink={this.props.onUnlink}
                actionDeleteText={this.props.actionUnlinkTest}
                noPagination={true}
                showConfirmationModal={false}
                customModalTitle={this.props.unlinkModalTitle}
              />

            </Row>

          </React.Fragment>
        )
      }
      else {
        return (
          <Row className="goepik-extra-big-top-margin">
            <h2>{I18n.l('labels.auditor')}</h2>
            <p className="goepik-text-lightGray-bold">{I18n.l('auditeds.details.needLinkAuditor')}</p>
          </Row>
        )
      }

    }
    return (
      <div><p className="goepik-text-lightGray-bold">{I18n.l('common.noResult')}</p></div >
    )
  }

  getAuditionsDone = async (array: any[], auditsPerMonth: number) => {
    let countsGoals: any = []
    this.setState({ auditsPerMonth })
    for (let audit of array) {
      if (audit.count > auditsPerMonth) {
        countsGoals.push(auditsPerMonth)
      }
      else {
        countsGoals.push(audit.count)
      }
    }
    const sumMonth = countsGoals && countsGoals.length > 0 ? countsGoals.reduce((a: any, b: any) => a + b) : 0
    this.setState({ auditedExecutedCount: sumMonth })
  }

  onChangeFilterAuditedOut = async (evt: any) => {
    this.setState({ isAuditedOut: evt.target.value })
    if (this.state.isAuditedOut) {
      this.getAuditionsDone(this.state.resultTable, this.state.currentProcess.auditedGoal.times)
    }
    else {
      const filterWithoutAuditedOut = this.state.resultTable.filter((e: any) => e.value.auditedOut === false || e.value.auditedOut === undefined)
      this.getAuditionsDone(filterWithoutAuditedOut, this.state.currentProcess.auditedGoal.times)
    }
  }

  getAuditsPerUser = (auditsArray: any[]) => {
    const IDs: any = []


    //this for loop is meant to create an array of objects in which the mutiple appears of him are turned into just one
    for (let audit of auditsArray) {
      let appearCount = 0;
      for (let ID of IDs) {
        if (audit.value.audited.id === ID.user) {
          appearCount += 1
        }
      }

      if (appearCount === 0) {
        IDs.push({ user: audit.value.audited.id, data: [] })
      }

    }
    //now that we have an object for id, we are going to push his info into the data property of the object
    for (let audit of auditsArray) {
      for (let ID of IDs) {
        if (audit.value.audited.id === ID.user) {
          ID.data.push(audit)
        }
      }
    }


    return IDs
  }

  returnSum = (formatedArray, currentProcess) => {
    let auditSum = 0;


    for (let person of formatedArray) {
      let sumMonth: any[] = []
      for (let data of person.data) {
        //here we are extracting the desired value out of the zillion things array/object the API returns us
        const value = sumMonth[`${data.month}`] || 0;
        sumMonth[`${data.month}`] = value + data.count;
      }

      //from this point on we are just formatting the numbers array and summing it 
      sumMonth = sumMonth.filter(el => {
        if (el != '') {
          return el
        }
      }).map(value => value > currentProcess.auditedGoal.times ? currentProcess.auditedGoal.times : value)

      if (sumMonth.length > 1) {
        sumMonth = sumMonth.reduce((total, num) => total + num)
      } else { sumMonth = sumMonth[0] }
      person.data = sumMonth


      auditSum = auditSum + person.data
    }

    return auditSum
  }

  renderAuditsTabs() {
    const { processesData: auditsData, auditedsTableData, auditorsTableData, currentProcess } = this.state;
    const { auditPersonType } = this.props;
    let executed = this.state.auditedExecutedCount;
    let data: any = undefined;
    let auditGoal: any = 0;

    let ticketsExecutedAudited: TicketsExecutedByAudited[] = [];



    if (this.props.auditPersonType == AuditPersonType.AUDITOR) {
      data = (this.state.auditedsTableData ? this.getAuditedsTableDataByAudit(this.state.currentAuditId) : undefined);

    }

    else if (this.props.auditPersonType == AuditPersonType.AUDITED) {

      data = (this.state.auditorsTableData ? this.getAuditorsTableDataByAudit(this.state.currentAuditId) : undefined);

    }
    if (this.props.auditor) {
      const auditeds = []
      const finalAuditeds = []
      if (data !== undefined) {
        data.data.forEach(element => {
          auditeds.push(element.id)
        });
        let table = this.state.resultTable
        if (table.length > 0) {
          for (let tableItem of table) {
            if (auditeds.indexOf(tableItem.value.audited.id) !== -1) {
              finalAuditeds.push(tableItem)
            }
          }

          const users = []
          for (let audited of finalAuditeds) {
            if (users.indexOf(audited.value.audited.id) === -1) {
              users.push(audited.value.audited.id)
            }
          }
        }

      }
    }


    historyTabData = this.getTabTickets(true);
    if(this.props.calledFromAuditedsPage){
      if (currentProcess && currentProcess.auditedGoal.type === FrequencyType.MONTHS){
        auditGoal = currentProcess.auditedGoal.times * 12
      } else if (currentProcess && currentProcess.auditedGoal.type === FrequencyType.YEARS){
        auditGoal = currentProcess.auditedGoal.times 
      }
      
    } else { 
    if (currentProcess && currentProcess.auditedGoal.type === FrequencyType.MONTHS) {
      if (data && data !== undefined) {
        if (data.data && data.data.length > currentProcess.minAuditedsByAuditor) {
          auditGoal = (currentProcess.auditedGoal.times * data.data.length * 12)
        }
        else {
          auditGoal = (currentProcess.auditedGoal.times * currentProcess.minAuditedsByAuditor * 12)
        }
      }
    }
    else if (currentProcess && currentProcess.auditedGoal.type === FrequencyType.YEARS) {
      if (data && data !== undefined) {
        if (data.data && data.data.length > currentProcess.minAuditedsByAuditor) {
          auditGoal = currentProcess.auditedGoal.times * data.data.length
        }
        else if (currentProcess && currentProcess !== undefined) {
          auditGoal = (currentProcess.auditedGoal.times * currentProcess.minAuditedsByAuditor)
        }
      }
    }
    }


    return (
      <Tabs defaultActiveKey={this.state.currentAuditId} onChange={this.changeAuditTab}>
        {auditsData.map((item: IProcess) => {
          return <TabPane tab={item.name} key={item.id}>
            {data == undefined && (
              <Row>
                {I18n.l("common.loadingData")}
              </Row>
            )}
            {(data && data.loading) || this.state.loadingDetails && (
              <Row>
                {I18n.l("common.loadingData")}
              </Row>
            )}
            {(data && !data.loading) && !this.state.loadingDetails &&
              (
                <>
                  <div>
                    <Radio.Group defaultValue={this.state.isAuditedOut} onChange={this.onChangeFilterAuditedOut} buttonStyle="solid">
                      <Radio.Button value={false}>{I18n.l('audits.auditedwithGroup')}</Radio.Button>
                      <Radio.Button value={true}>{I18n.l('audits.auditedOut')}</Radio.Button>
                    </Radio.Group>
                    <Row className="goepik-component-padding">
                      <Col xs={12} sm={12} md={6} lg={5} className="audit-count-title">
                        <span className="title2">{I18n.l('table.auditors.goals')}</span>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={{ span: 12 }}>
                        <Progress percent={((executed / auditGoal) * 100)} showInfo={false} />
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={{ span: 3, offset: 1 }}>
                        {this.props.auditor ? executed : this.state.auditedExecutedCount} {I18n.l('common.of')} {auditGoal}
                        <span style={{ marginLeft: ' 5px' }} >{I18n.l('table.auditors.processes').toLowerCase()}</span>
                        <span>{` (${I18n.l('common.byYear')})`}</span>
                      </Col>
                    </Row>
                    <Divider style={{ marginTop: '48px' }} />
                  </div>
                  {auditPersonType === AuditPersonType.AUDITOR && (
                    !!auditedsTableData && (
                      <Row className="goepik-medium-top-margin">
                        {this.renderAuditedsDataTable(data, ticketsExecutedAudited)}
                      </Row>
                    )
                  )}
                  {auditPersonType === AuditPersonType.AUDITED && (
                    !!auditorsTableData && (
                      <Row className="goepik-medium-top-margin">
                        {this.renderAuditorsDataTable()}
                      </Row>
                    )
                  )}

                  {(this.state.historyTableData && this.state.historyTableData.length > 0) && (
                    <div >
                      <Table
                        columns={this.props.auditPersonType === AuditPersonType.AUDITOR ? tableColumnsAuditor : tableColumnsAudited}
                        data={this.state.historyTableData}
                        noPagination={true}
                        showConfirmationModal={false}
                        onVisualize={this.toggleVisualize}

                      />

                      {this.state.curOffset && (
                        <Button
                          className="loading-more"
                          type="primary"
                          size='large'
                          ghost
                          loading={this.state.loadingSeeMore ? true : false}
                          onClick={() => this.loadMoreHistory()}>{I18n.l('common.seeMore')}</Button>
                      )}
                    </div>
                  )}

                  {(this.state.historyTableData && this.state.historyTableData.length === 0 && !this.state.loadingHistory) && <span style={{ fontWeight: 'bold', fontSize: '20px', marginTop: '2rem' }} >{I18n.l("history.ticketDetailsEmpty")}</span>}

                </>
              )}
            <Modal
              visible={this.state.visibleModal}
              footer={false}
              className="goepik-modal-fullscreen"
              onCancel={this.toggleVisualize}
            >
              {this.state.loadingTicket &&
                I18n.l('common.loadingData')
              }
              {(this.state.currentTicket && !this.state.loadingTicket) && (
                <>
                  <h1 style={{ fontSize: '55px' }} >{I18n.l('history.detailTitle')}</h1>
                  <div style={{ paddingLeft: '100px' }} >
                    <HistoryComponentEhss
                      registers={this.state.currentTicket.items}
                      extralfield={this.state.extraFields}
                    />
                  </div>
                </>
              )}
            </Modal>
          </TabPane>
        })}

      </Tabs>
    )
  }

  getTabTickets(ofCurrentYear?: boolean) {
    const historyTabData = (this.state.historyData ? this.getHistoryDataByAudit(this.state.currentAuditId) : undefined);
    if (historyTabData) {
      if (historyTabData.data) {
        if (historyTabData.data.length > 0) {
          if (ofCurrentYear) {
            const firstMoment = new Date(new Date().getFullYear(), 0, 1).getTime();

            const newItems = historyTabData.data.filter((t: any) => t.startAt > firstMoment);
            const newHistory = { ...historyTabData, data: newItems };
            return newHistory;
          }
          return historyTabData;
        }
      }
    }
    return undefined;
  }

  changeAuditTab = async (auditTabId: string) => {
    this.setState({ loadingDetails: true })
    const { processesData } = this.state;
    let processData = processesData.find((item: IProcess) => item.id === auditTabId);
    let goals = processesData.find((item: IProcess) => item.id === auditTabId);

    if (this.props.auditGoals && goals)
      this.props.auditGoals(goals.auditedGoal.times);

    if (this.props.setAuditedMinByAuditor)
      this.props.setAuditedMinByAuditor(processData !== undefined ? processData.minAuditedsByAuditor : '');
    if (this.props.setAuditedMaxByAuditor)
      this.props.setAuditedMaxByAuditor(processData !== undefined ? processData.maxAuditedsByAuditor : '');


    this.setState({
      currentProcess: processData,
      currentAuditId: auditTabId,
      currentAuditedMaxByAuditor: processData ? processData.maxAuditedsByAuditor : this.state.currentAuditedMaxByAuditor,
      currentAuditedMinByAuditor: processData ? processData.minAuditedsByAuditor : this.state.currentAuditedMinByAuditor,
    });
    await this.getMadeAuditsJSON().then(response => this.getAuditionsDone(response, this.state.currentProcess.auditedGoal.times));
    this.props.auditChanged(auditTabId);

    if (this.props.auditChangedName) {
      this.props.auditChangedName(processData !== undefined ? processData.name : '');
    }
    this.loadTabData(auditTabId);

    await this.getHistoryData(true, true)
    this.setState({ loadingDetails: false })

  }

  render() {
    const {
      personData
    } = this.props;

    const {
      loadingAudits,
      processesData: auditsData
    } = this.state;
    return (
      <AppContext.Consumer>
        {({ activeUnitId }) => (
          this.setUnit(activeUnitId),

          <Wrapper>
            <p className="name-title">{personData.name}</p>
            <br />
            {this.extraInfos && (
              <ExtrasInfoList>
                <List
                  grid={{ gutter: 22, xs: 1, sm: 2, md: 4, lg: 6, xl: 8, xxl: 8 }}
                  dataSource={this.extraInfos}
                  renderItem={(item: any) => (
                    <List.Item>
                      <Card bodyStyle={{ padding: "3px" }} bordered={false} title={item.title}>{item.content}</Card>
                    </List.Item>
                  )}
                />
              </ExtrasInfoList>
            )}

            <Row className={"goepik-component-padding"}>
              {loadingAudits && (
                <Row>
                  <p>{I18n.l('common.loadingProcesses')}</p>
                </Row>
              )}
              {loadingAudits === false && (auditsData === undefined || auditsData.length === 0) && (
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    <p className="goepik-text-lightGray-bold">
                      {I18n.l((this.props.auditPersonType === AuditPersonType.AUDITOR)
                        ? 'auditors.errors.noAudits'
                        : 'auditeds.errors.noAudits')}
                    </p>
                  </Col>
                </Row>
              )}
              {(loadingAudits === false && (!!auditsData && auditsData.length > 0)) && (
                <Row>
                  {this.renderAuditsTabs()}
                </Row>
              )}
            </Row>



          </Wrapper>
        )}
      </AppContext.Consumer>
    );
  }
}

const ExtrasInfoList = styled.div` 
    .ant-card-head{ 
        border-bottom: none; 
        padding: 3px; 
    } 
    .ant-card-head-title{ 
        padding-bottom: 0px; 
    } 
    .ant-card-bordered{ 
        .ant-card-body{ 
            padding: 3px; 
        } 
    } 
`;

const Wrapper = styled.div` 
 
    .AuditPersonDetails { 
        .action-buttons { 
            text-align: left; 
            button { 
                width: 100px; 
                white-space: initial; 
                text-align: left; 
                span { 
                    padding: 0 
                } 
            } 
        } 
    } 
    width: 100%; 
    .name-title{ 
        font-size: 33px; 
        font-weight: bold; 
    } 
     
    .audit-count-title{ 
        max-width: 130px; 
    } 
     
    .title2{ 
        font-size: 20px; 
        font-weight:bold; 
    } 
    .title3{ 
        font-size: 16px; 
        font-weight:bold; 
    } 
    .ant-divider-horizontal { 
        display: block; 
        width: 100%; 
        height: 2px; 
        margin: 24px 0; 
        clear: both; 
    } 
                 
    .ant-table-wrapper { 
        width: 99.9%; 
             
    button { 
        border: 0; 
        } 
    } 
 
    .see-more-btn { 
        font-weight: bold; 
    } 
         
    .ant-progress-inner{ 
        background-color: ${Theme.standard.lightGray} 
 
    } 
    .ant-avatar.ant-avatar-icon { 
        font-weight: bold; 
        text-align: center; 
        width: 33px; 
        font-size: 23px; 
        height: 33px; 
    } 
                     
    .action-buttons { 
        display: block; 
        text-align: right; 
        button { 
            margin: 0 0 3px 0px; 
            padding: 3px; 
            width: 70px; 
        } 
    } 
                 
    table { 
        td { 
            .disabled { 
                color: #ccc; 
            } 
        } 
    } 
    `;
